import script from "./AdditionalQuestionsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdditionalQuestionsPage.vue?vue&type=script&setup=true&lang=js"

import "./AdditionalQuestionsPage.vue?vue&type=style&index=0&id=22684a84&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22684a84"]])

export default __exports__